import {Directive, TemplateRef} from "@angular/core";
import {DxPageHeaderBaseDirective} from "./dx-page-header-base.directive";

/**
 * Структурная директива для переопределения шаблона области под раздел помощи\справки в шапке.
 * @publicApi
 */
@Directive({selector: '[dxPageHeaderHelpBar]'})
export class DxPageHeaderHelpBarDirective extends DxPageHeaderBaseDirective {
  constructor(public template: TemplateRef<any>) {
    super();
  }
}
